var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('candidate-feed',{attrs:{"activityType":['note', 'evaluation', 'task', 'move', 'qualification', 'meetinsight', 'email', 'event', 'questionnaire', 'intervideo', 'intervoice']}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31478382","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate/Timeline/CandidateTimeline.vue
// module id = null
// module chunks = 